import React, { useState } from "react";
import axiosInstance from "../api/axiosInstance";
import "./FeedbackPage.css";

export default function FeedbackPage() {

  const [type, setType] = useState("service");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);


  const sendFeedback = async () => {

    if (!message.trim()) {
      alert("Please write feedback");
      return;
    }

    try {

      setLoading(true);

      await axiosInstance.post("/send-feedback/", {
        feedback_type: type,
        message: message,
      });

      setSuccess(true);
      setMessage("");

    } catch {

      alert("Error sending feedback");

    } finally {

      setLoading(false);

    }

  };


  return (

    <div className="feedback-container">

      <div className="feedback-card">

        <h2>💬 Send Feedback</h2>

        <p className="subtitle">
          Help us improve your experience
        </p>


        {/* Type */}

        <label>Feedback Type</label>

        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
        >

          <option value="service">😊 Service</option>

          <option value="suggestion">💡 Suggestion</option>

          <option value="complaint">😞 Complaint</option>

          <option value="other">📦 Other</option>

        </select>


        {/* Message */}

        <label>Your Message</label>

        <textarea

          placeholder="Write your feedback here..."

          value={message}

          onChange={(e) => setMessage(e.target.value)}

          maxLength="500"

        />


        <div className="char-count">

          {message.length}/500

        </div>



        {/* Button */}

        <button

          onClick={sendFeedback}

          disabled={loading}

        >

          {loading ? "Sending..." : "Submit Feedback"}

        </button>


        {/* Success */}

        {success && (

          <div className="success">

            ✅ Feedback sent successfully

          </div>

        )}


      </div>

    </div>

  );

}